import { createContext, useContext, useState, useCallback, useEffect } from "react";
import { translations, resolve, interpolate } from "@/lib/i18n";

const LanguageContext = createContext(null);
const STORAGE_KEY = "sg_lang";
const SUPPORTED = ["pl", "en", "cs", "de"];

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return "pl";
    const saved = localStorage.getItem(STORAGE_KEY);
    return SUPPORTED.includes(saved) ? saved : "pl";
  });

  useEffect(() => {
    if (typeof document !== "undefined") document.documentElement.lang = lang;
  }, [lang]);

  const setLang = useCallback((next) => {
    setLangState(next);
    if (typeof window !== "undefined") localStorage.setItem(STORAGE_KEY, next);
  }, []);

  const t = useCallback(
    (path, vars) => {
      const val = resolve(translations[lang], path);
      if (val == null) return resolve(translations.pl, path) ?? path;
      return interpolate(val, vars);
    },
    [lang]
  );

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
}
